import React from 'react';
import '../styles/home.css';
import desktop_logo from '../assets/icons/logo_desktop.svg';
import home_technology from '../assets/img/home_technology.svg';
import Button from '../components/Button';

import InformationCard from '../components/InformationCard';
import MoreInfo from '../components/MoreInfo';

import testosterone_icon from '../assets/icons/testosterone.svg';
import libido_icon from '../assets/icons/libido.svg';
import body_fat_icon from '../assets/icons/body-fat.svg';
import muscle_strength_icon from '../assets/icons/strength.svg';
import qol_icon from '../assets/icons/qol.svg';
import energy_icon from '../assets/icons/energy.svg';
import exercise_recovery_icon from '../assets/icons/exercise-recovery.svg';

import fenugreek from '../assets/img/fenugreek.svg'
import black_ginger from '../assets/img/black_ginger.svg';

import capsules_icon from '../assets/icons/capsule.svg';
import sachets_icon from '../assets/icons/sachets.svg';
import beadlets_icon from '../assets/icons/beadlets.svg';
import gummies_icon from '../assets/icons/gummies.svg';

const iconTab =
    [
        {
            label: "increase testosterone",
            icon: testosterone_icon
        },
        {
            label: "Boost libido",
            icon: libido_icon
        },
        {
            label: "Reduce body fat",
            icon: body_fat_icon
        },
        {
            label: "Muscle strength & mass",
            icon: muscle_strength_icon
        },
        {
            label: "Improve QOL",
            icon: qol_icon
        },
        {
            label: "Energy",
            icon: energy_icon
        },
        {
            label: "Exercise recovery",
            icon: exercise_recovery_icon
        }
    ]

const galenicTab =
    [
        {
            label: "Capsules",
            icon: capsules_icon
        },
        {
            label: "Sachets",
            icon: sachets_icon
        },
        {
            label: "Beadlets",
            icon: beadlets_icon
        },
        {
            label: "Gummies",
            icon: gummies_icon
        }
    ]

const Home = () => {
    return (
        <div className='home-global-container'>
            <div className="home-container">
                <div className='home-text-container'>
                    <img src={desktop_logo} alt="Logo" className="home-logo" />
                    <h1>
                        <span className="home-h1-highlight color">Unique formulation</span><br />
                        <span className="home-h1-highlight">for muscle endurance</span>
                        <Button
                            label={"Read the studies"}
                            bgColor={"#AD7B28"}
                            borderColor={"none"}
                            color={"white"}
                            path={"/studies"}
                        />
                        <Button
                            label={"discover Insitu360™"}
                            bgColor={"transparent"}
                            borderColor={"#AD7B28"}
                            color={"#AD7B28"}
                            path={"/technology"}
                        />
                    </h1>
                </div>
            </div>
            <div className='home-technology-container'>
                <div className='home-technology-container-text'>
                    <h2 className='home-technology-title'>What is Testolift™?</h2>
                    <p className='home-technology-text margin-bottom'>
                        Testolift™ is a branded nutraceutical ingredient from Padma groups tailored using scientifically proven ingredients Fenugreek and black ginger , anchored by insitu360 technology
                    </p>
                    <Button
                        label={"Read the studies"}
                        bgColor={"transparent"}
                        borderColor={"#AD7B28"}
                        color={"#AD7B28"}
                        path={"/studies"}
                    />
                </div>
                <img src={home_technology} alt="Technology" className="home-technology-image" />
                <div className='home-technology-container-text'>
                    <h2 className='home-technology-title'>What is insitu360™<br /> technology ?</h2>
                    <p className='home-technology-text'>
                        A cutting-edge, branded technology that enhances the efficacy of multiple molecules through a streamlined, single-step process combining extraction, molecular complexation, and purification.
                    </p>
                    <Button
                        label={"learn about the technology"}
                        bgColor={"transparent"}
                        borderColor={"#AD7B28"}
                        color={"#AD7B28"}
                        path={"/technology"}
                    />
                </div>
            </div>
            <div className='home-cta-container'>
                <h2 className='home-cta-title'>
                    <span className='home-cta-title-highlight color'>
                        testolift™ {` `}
                    </span>
                    benefits
                </h2>
                <div className='home-cta-icon-container-wrapper'>
                    {
                        iconTab.map((item, index) => (
                            <div className='home-cta-icon-container' key={index}>
                                <img src={item.icon} alt={item.label} className='home-cta-icon' />
                                <p className='home-cta-icon-label'>{item.label}</p>
                            </div>
                        ))
                    }
                </div>
            </div>
            <div className='home-major-active-cotainer'>
                <h2 className='home-major-active-title'>
                    what are the major active <br /> components in <span className='color'>Testolift™</span> ?
                </h2>
                <div className='home-major-active-card-container'>
                    <InformationCard
                        title={"Fenugreek extract"}
                        name={"Trigonella foenum graecum"}
                        img={fenugreek}
                        type={1}
                    />
                    <InformationCard
                        title={"Black Ginger Extract"}
                        name={"Kaempferia Parviflora"}
                        img={black_ginger}
                        type={2}
                    />
                </div>
            </div>
            <div className='home-galenic-container'>
                <h2 className='home-galenic-title'>
                    <span className='color'>4 </span> galenic <br /> forms <br /> available
                </h2>

                <div className='home-galenic-grid'>
                    {galenicTab.map((item, index) => (
                        <div className='home-galenic-card' key={index}>
                            <img src={item.icon} alt={item.label} className='home-galenic-icon' />
                            <p className='home-galenic-label'>{item.label}</p>
                        </div>
                    ))}
                </div>
            </div>
            <MoreInfo />
        </div>
    );
};

export default Home;
